import ArrowRight from "@/assets/ArrowRight.svg";
import { Button, Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { format } from "date-fns";
import { useLink } from "@/hooks/useLink";
import { Banner } from "@/ui/Banner";
import clsx from "classnames";
import classes from "./styles.module.scss";
import sourceflowEnums from "@/sourceflow.enums";

export const JobPageIntroSection = ({
  className,
  title,
  salary_package,
  location,
  external_reference,
  published_at,
  categories,
  consultant_name,
}) => {
  const locale = useLocale();
  const link = useLink();
  const types = categories.find((i) => i.id === sourceflowEnums.categories.type.id);
  const workplace = categories.find((i) => i.id === sourceflowEnums.categories.working_environment.id);

  return (
    <Banner
      className={clsx(className, classes.intro)}
      title={<h1 dangerouslySetInnerHTML={{ __html: title }} />}
      backlink={{ url: link("jobs"), label: <DynamicText path={`job.link.back.${locale}`} /> }}
      image={{ path: "page.job.banner.image", src: "/assets/banners/default.png" }}
    >
      <Row className="mt-5">
        <Col xs={12} md={6} lg={4}>
          <dl>
            <dt>
              <DynamicText path={`page.job.details.salary.${locale}`} />
            </dt>
            <dd dangerouslySetInnerHTML={{ __html: salary_package }} />
          </dl>
          <dl>
            <dt>
              <DynamicText path={`page.job.details.location.${locale}`} />
            </dt>
            <dd
              dangerouslySetInnerHTML={{
                __html: location.includes("City of ") ? location.replace("City of ", "").split(",")[0] : location,
              }}
            />
          </dl>
          {types && (
            <dl>
              <dt>
                <DynamicText path={`page.job.details.type.${locale}`} />
              </dt>
              <dd>{types.values.map((i) => i.name).join(", ")}</dd>
            </dl>
          )}
          {workplace && (
            <dl>
              <dt>
                <DynamicText path={`page.job.details.workplace.${locale}`} />
              </dt>
              <dd>{workplace.values.map((i) => i.name).join(", ")}</dd>
            </dl>
          )}
        </Col>
        <Col xs={12} md={6} lg={4}>
          <dl>
            <dt>
              <DynamicText path={`page.job.details.published.${locale}`} />
            </dt>
            <dd dangerouslySetInnerHTML={{ __html: format(new Date(published_at), "MMM d, yyyy") }} />
          </dl>
     
          <dl>
            <dt>
              <DynamicText path={`page.job.details.reference.${locale}`} />
            </dt>
            <dd dangerouslySetInnerHTML={{ __html: external_reference }} />
          </dl>
          <div className="d-flex justify-content-end mt-3">
            <Button variant="primary" href="#apply">
              <DynamicText path={`page.job.apply.link.${locale}`} className="me-3" />
              <ArrowRight width="14" height="12" />
            </Button>
          </div>
        </Col>
      </Row>
    </Banner>
  );
};
